var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-cell',{staticClass:"my_cell"},[_c('div',{staticClass:"my_cell_box"},[_c('div',{staticClass:"my_cell_label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"my_cell_content"},[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }